// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('jobs', {
    parent: 'main',
    url: '/jobs',
    views: {
      'main-content': {
        template: '<jobs></jobs>',
      },
    },
    data: { pageTitle: 'Jobs' },
  });

  $stateProvider.state('jobs.detail', {
    url: '/:jobId',
    views: {
      'main-content@main': {
        controller: 'JobDetailsController as vm',
        template: '<job-details job-id="vm.jobId"></job-details>',
      },
    },
    data: { pageTitle: 'Job details' },
  });
};

class JobDetailsController {
  constructor($stateParams) {
    'ngInject';
    this.jobId = Number($stateParams.jobId);
  }
}

angular
  .module('main.jobs', [])
  .config(config)
  .controller('JobDetailsController', JobDetailsController);
